// extracted by mini-css-extract-plugin
export default {"footer":"_2E2EQneJ text-muted","footerContainer":"_1V7LiUKr","footerLinks":"_19TENdit","feedbackBtn":"OBCAh7Si"};